import {API, graphqlOperation} from "aws-amplify";

const performGQL = async (variables, operation) => {
    const response = await API.graphql(
        graphqlOperation(operation, variables)
    )
    let key = Object.keys(response.data)[0]
    return response.data[key]
}
const listAllAndSetItems = async (variables, operation, setItems) => {
    const getItems = async (vars)=>{
        const {items, nextToken: newNextToken} = await performGQL(vars, operation);

        if (items.length) {
            setItems(items.filter(item => !item.deleted))
        }
        if (newNextToken) {
            await getItems({
                ...vars,
                nextToken: newNextToken
            })
        }
    }
    return await getItems(variables)
}

function toleranceDifference(amount1, amount2, tolerance) {

    let diff = Math.abs(amount2 - amount1)

    if ( diff <= tolerance){
        return false
    }
    return amount2 - amount1
}

export {
    performGQL,
    listAllAndSetItems,
    toleranceDifference
}